
export function getSimpleOffers(loan, requestedAmount = false) {
    const offers = loan.loanOfferData.offers;
    const currentRequestedAmount = loan.requestedAmount || 0;
    if (offers === null || offers === undefined) return {};

    const maxOffer = loan.loanOfferData.maxLoanAmount;
    const minOffer = loan.loanOfferData.minLoanAmount;
    const cardId = loan.loanOfferData.card.id;
    let customizedOffer;
    const requestedAmountAvailable = currentRequestedAmount >= minOffer && currentRequestedAmount <= maxOffer;
    
    let groupedOffers = Object.entries(offers)
        .reduce((acc, [key, value]) => {
            const amountGroup = value.amount.toString();
            if (!acc[amountGroup]) {
                acc[amountGroup] = [];
            }
            acc[amountGroup].push([key, value]);
            return acc;
        }, {});

    let chainedOffers = Object.entries(groupedOffers)
        .map(([key, value]) => [parseInt(key, 10), value])
        .sort((a, b) => b[0] - a[0])
        .map((pair) => {
            if (!customizedOffer || pair[0] > customizedOffer) {
                customizedOffer = pair[0];
            }
            return pair;
        })
        .sort((a, b) => Math.abs(a[0] - (requestedAmount || 0)) - Math.abs(b[0] - (requestedAmount || 0)));

    const filteredOffers = Object.fromEntries(chainedOffers[0][1]);

    const sortedOffers = Object.entries(offers)
        .map(([key, value]) => {
        value.id = key;
        return value;
    })
        .sort((a, b) => a.amount - b.amount || a.duration - b.duration);

    const findLowest = (duration) => Object.keys(filteredOffers).find(key => filteredOffers[key].duration === duration);

    const lowestRateKey = findLowest(36);
    const lowestPaymentKey = findLowest(60);
    const lowestRate = { [lowestRateKey]: filteredOffers[lowestRateKey] };
    const lowestPayment = { [lowestPaymentKey]: filteredOffers[lowestPaymentKey] };

    return {
        cardId,
        customizedOffer,
        offers: { lowestRate, lowestPayment, sortedOffers },
        maxOffer,
        minOffer,
        requestedAmountAvailable
    };
}

export default {
    getSimpleOffers
};